var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFolder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.29622 4.56201C4.67739 4.56201 4.08389 4.80788 3.64631 5.24546C3.20872 5.68305 2.96289 6.27651 2.96289 6.89535V9.89369H25.1296V9.22868C25.1296 8.60984 24.8837 8.01638 24.4461 7.5788C24.0086 7.14121 23.4151 6.89535 22.7962 6.89535H12.2962L10.6396 5.2387C10.2021 4.80479 9.61072 4.56152 8.99456 4.56201H5.29622Z",
    fill: "#5096FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.91602 9.9165H25.0827V19.8332C25.0827 20.452 24.8369 21.0455 24.3993 21.4831C23.9617 21.9207 23.3682 22.1665 22.7493 22.1665H5.24935C4.63051 22.1665 4.03705 21.9207 3.59947 21.4831C3.16188 21.0455 2.91602 20.452 2.91602 19.8332V9.9165Z",
    fill: "#DBECFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFolder);
export default __webpack_public_path__ + "static/media/icon_folder.9aa2e99aff4f5d278d7183d7a40f2bec.svg";
export { ForwardRef as ReactComponent };